import styled from 'styled-components'
import { AUTO_ATTR_KEY, AutomationId } from 'utils/automationUtil'

const AutoIdWrapper = styled.div.attrs({
  [AUTO_ATTR_KEY]: AutomationId.metricGrid.item
})``

export default AutoIdWrapper
